/**
 * Collection of datapoints used by Accessible content setting
 */
export default {
    AccessibleContentSetting: {
        datapoint: {
            name: 'AccessibleContentSetting',
            customData: (value: boolean) => [value],
        },
    },
};
